// export default function fitText({
//   el,
//   box,
//   maxWidth = null,
//   maxHeight = null,
//   minFontSize = 10,
//   debug = false,
//   flip = false,
//   clipOnly = false,
//   singleLine = false,
//   boxWidthOnly = false,
//   boxMultiplier = [1, 1],
//   clip = "...",
//   htmlClip = null,
//   afterFit = null,
//   maxWidthLimit = 999999,
//   maxHeightLimit = 999999,
// }) {
//   if (!el) throw new Error("param `el` is missed for FitText");
//   if (!(el instanceof HTMLElement))
//     throw new Error("param `el` must be an instance of HTMLElement");
//   if (box && !(box instanceof HTMLElement))
//     throw new Error("param `box` must be an instance of HTMLElement");
//   if (
//     boxMultiplier &&
//     boxMultiplier instanceof Array &&
//     boxMultiplier.length !== 2
//   )
//     throw new Error("param `boxMultiplier` must be an array of two numbers");

//   let _style;
//   let fitResult;

//   el.style.removeProperty("font-size");

//   if (typeof maxHeight === "function") maxHeight = Math.ceil(maxHeight());
//   if (typeof maxWidth === "function") maxWidth = Math.ceil(maxWidth());
//   if (typeof minFontSize === "function") minFontSize = Math.ceil(minFontSize());

//   if (!el.__originalText) {
//     el.__originalText = el.innerHTML;
//   } else {
//     el.innerHTML = el.__originalText;
//   }

//   const originalContent = el.__originalText;

//   if (!maxHeight && (clipOnly || singleLine)) {
//     _style = window.getComputedStyle(el);
//     maxHeight = Math.round(Number(_style.lineHeight.replace("px", "")));
//   }

//   if (box) {
//     maxWidth =
//       maxWidth || (box?.offsetWidth || maxWidthLimit) * boxMultiplier[0];
//     maxHeight = boxWidthOnly
//       ? maxHeight
//       : (box?.offsetHeight || maxHeightLimit) * boxMultiplier[1];
//   }

//   maxWidth = maxWidth || maxWidthLimit;
//   maxHeight = maxHeight || maxHeightLimit;

//   if (flip) {
//     let temp = maxHeight;
//     maxHeight = maxWidth;
//     maxWidth = temp;
//   }

//   const style = _style || window.getComputedStyle(el);
//   const maxFontSize = Math.round(Number(style.fontSize.replace("px", "")));

//   let testFitting = 0;
//   const fitting = () => {
//     testFitting++;

//     if (testFitting > 2000) {
//       return true;
//     }

//     if (debug) {
//       console.log(
//         `maxWidth: ${maxWidth}`,
//         `maxHeight: ${maxHeight}`,
//         `width: ${el.offsetWidth}`,
//         `scrollWidth: ${el.scrollWidth}`,
//         `height: ${el.offsetHeight}`,
//         `scrollHeight: ${el.scrollHeight}`,
//         maxFontSize,
//         minFontSize,
//         el
//       );
//     }

//     return (
//       el.scrollWidth <= maxWidth &&
//       (maxHeight ? el.offsetHeight <= maxHeight : true)
//     );
//   };

//   if (fitting()) {
//     fitResult = {
//       text: el.__originalText,
//       fontSize: maxFontSize,
//     };

//     afterFit?.(fitResult);

//     return fitResult;
//   }

//   // doesn't fit
//   let fontSizeTry = maxFontSize - 1;

//   if (!clipOnly) {
//     while (!fitting() && fontSizeTry > minFontSize) {
//       el.style.fontSize = `${fontSizeTry}px`;
//       fontSizeTry -= 1;
//       if (singleLine)
//         maxHeight = Math.round(Number(style.lineHeight.replace("px", "")));
//     }

//     if (fitting()) {
//       fitResult = {
//         text: el.__originalText,
//         fontSize: fontSizeTry + 1,
//       };

//       afterFit?.(fitResult);

//       return fitResult;
//     }
//   }

//   let tryMaxCharLength = originalContent.length;
//   while (!fitting()) {
//     el.innerHTML = clipString(originalContent, tryMaxCharLength, clip);
//     if (htmlClip) el.innerHTML += htmlClip;
//     tryMaxCharLength -= 1;
//   }

//   fitResult = {
//     text: el.innerHTML,
//     fontSize: fontSizeTry + 1,
//   };

//   afterFit?.(fitResult);

//   return fitResult;
// }

// function clipString(str, length, clip) {
//   return length > str.length
//     ? str
//     : str.slice(0, Math.max(0, length - clip.length)) + clip;
// }

/**
 * fitText - Text fitting utility
 * Based on textFit v2.3.1 by STRML
 * MIT License
 *
 * To use: fitText(document.getElementById('target-div'), options);
 *
 * Will make the *text* content inside a container scale to fit the container
 * The container is required to have a set width and height
 * Uses binary search to fit text with minimal layout calls.
 */

/**
 * fitText - Text fitting utility
 * Based on textFit v2.3.1 by STRML
 * MIT License
 *
 * To use: fitText(document.getElementById('target-div'), options);
 *
 * Will make the *text* content inside a container scale to fit the container
 * The container is required to have a set width and height
 * Uses binary search to fit text with minimal layout calls.
 */
/**
 * fitText - Text fitting utility
 * Based on textFit v2.3.1 by STRML
 * MIT License
 *
 * To use: fitText(document.getElementById('target-div'), options);
 *
 * Will make the *text* content inside a container scale to fit the container
 * The container is required to have a set width and height
 * Uses binary search to fit text with minimal layout calls.
 */

// FIXME: Implementation found on internet, no clue why this works better
/**
 * fitText - Text fitting utility
 * Based on textFit v2.3.1 by STRML
 * MIT License
 *
 * To use: fitText(document.getElementById('target-div'), options);
 *
 * Will make the *text* content inside a container scale to fit the container
 * The container is required to have a set width and height
 * Uses binary search to fit text with minimal layout calls.
 */

const defaultSettings = {
  alignHoriz: false, // if true, fitText will set text-align: center
  multiLine: false, // if true, fitText will not set white-space: no-wrap
  detectMultiLine: true, // disable to turn off automatic multi-line sensing
  minFontSize: 6,
  maxFontSize: 80,
  reProcess: false, // if true, fitText will re-process already-fit nodes. Set to 'false' for better performance
  widthOnly: false, // if true, fitText will fit text to element width, regardless of text height
  afterFit: null, // callback function called after fitting is complete
  parentNode: null, // parent element to fit to (overrides element's own dimensions)
  parentFitMode: "both", // 'width', 'height', or 'both' - which parent dimension to fit to
  lineHeight: null, // line height value (as string) to apply during fitting
};

function fitText(els, options = {}) {
  if (!els) return;

  const settings = {};
  for (const key in defaultSettings) {
    if (options.hasOwnProperty(key)) {
      settings[key] = options[key];
    } else {
      settings[key] = defaultSettings[key];
    }
  }

  if (typeof els.toArray === "function") {
    els = els.toArray();
  }

  // Support passing a single el
  const elType = Object.prototype.toString.call(els);
  if (
    elType !== "[object Array]" &&
    elType !== "[object NodeList]" &&
    elType !== "[object HTMLCollection]"
  ) {
    els = [els];
  }

  // Process each el we've passed.
  for (let i = 0; i < els.length; i++) {
    processItem(els[i], settings);
  }

  // Call afterFit callback if provided
  if (settings.afterFit && typeof settings.afterFit === "function") {
    settings.afterFit(els);
  }
}

/**
 * The meat. Given an el, make the text inside it fit its parent.
 * @param  {DOMElement} el       Child el.
 * @param  {Object} settings     Options for fit.
 */
function processItem(el, settings) {
  if (
    !isElement(el) ||
    (!settings.reProcess && el.getAttribute("textFitted"))
  ) {
    return false;
  }

  // Set textFitted attribute so we know this was processed.
  if (!settings.reProcess) {
    el.setAttribute("textFitted", 1);
  }

  let innerSpan, originalHeight, originalHTML, originalWidth;
  let low, mid, high;

  // Get element data.
  originalHTML = el.innerHTML;

  // Use custom parent dimensions if parentNode is specified
  if (settings.parentNode && isElement(settings.parentNode)) {
    const parent = settings.parentNode;

    if (
      settings.parentFitMode === "width" ||
      settings.parentFitMode === "both"
    ) {
      originalWidth = innerWidth(parent);
    } else {
      originalWidth = innerWidth(el);
    }

    if (
      settings.parentFitMode === "height" ||
      settings.parentFitMode === "both"
    ) {
      originalHeight = innerHeight(parent);
    } else {
      originalHeight = innerHeight(el);
    }

    // Override widthOnly based on parentFitMode
    if (settings.parentFitMode === "width") {
      settings.widthOnly = true;
    }
  } else {
    originalWidth = innerWidth(el);
    originalHeight = innerHeight(el);
  }

  // Don't process if we can't find box dimensions
  if (!originalWidth || (!settings.widthOnly && !originalHeight)) {
    const targetElement = settings.parentNode
      ? "parent element"
      : "target element";
    const elementHTML = settings.parentNode
      ? settings.parentNode.outerHTML
      : el.outerHTML;

    if (!settings.widthOnly)
      throw new Error(
        `Set a static height and width on the ${targetElement} ${elementHTML} before using fitText!`
      );
    else
      throw new Error(
        `Set a static width on the ${targetElement} ${elementHTML} before using fitText!`
      );
  }

  // Add textFitted span inside this container.
  if (originalHTML.indexOf("textFitted") === -1) {
    innerSpan = document.createElement("span");
    innerSpan.className = "textFitted";
    // Inline block ensure it takes on the size of its contents, even if they are enclosed
    // in other tags like <p>
    innerSpan.style["display"] = "inline-block";
    innerSpan.innerHTML = originalHTML;
    el.innerHTML = "";
    el.appendChild(innerSpan);
  } else {
    // Reprocessing.
    innerSpan = el.querySelector("span.textFitted");
  }

  // Apply line height if specified
  if (settings.lineHeight) {
    innerSpan.style["line-height"] = settings.lineHeight;
  }

  // Prepare & set alignment
  if (settings.alignHoriz) {
    el.style["text-align"] = "center";
    innerSpan.style["text-align"] = "center";
  }

  // Check if this string is multiple lines
  // Not guaranteed to always work if you use wonky line-heights
  let multiLine = settings.multiLine;
  if (settings.detectMultiLine && !multiLine) {
    // Use line height for multi-line detection if specified
    const lineHeightPx = settings.lineHeight
      ? getLineHeightInPixels(innerSpan, settings.lineHeight)
      : parseInt(window.getComputedStyle(innerSpan)["font-size"], 10);

    if (innerSpan.getBoundingClientRect().height >= lineHeightPx * 2) {
      multiLine = true;
    }
  }

  // If we're not treating this as a multiline string, don't let it wrap.
  if (!multiLine) {
    el.style["white-space"] = "nowrap";
  }

  low = settings.minFontSize;
  high = settings.maxFontSize;

  // Binary search for highest best fit
  let size = low;
  while (low <= high) {
    mid = (high + low) >> 1;
    innerSpan.style.fontSize = mid + "px";

    // Update line height after changing font size if specified
    if (settings.lineHeight) {
      innerSpan.style["line-height"] = settings.lineHeight;
    }

    const innerSpanBoundingClientRect = innerSpan.getBoundingClientRect();
    if (
      innerSpanBoundingClientRect.width <= originalWidth &&
      (settings.widthOnly ||
        innerSpanBoundingClientRect.height <= originalHeight)
    ) {
      size = mid;
      low = mid + 1;
    } else {
      high = mid - 1;
    }
  }
  // found, updating font if differs:
  if (innerSpan.style.fontSize != size + "px") {
    innerSpan.style.fontSize = size + "px";
    // Ensure line height is applied to final font size
    if (settings.lineHeight) {
      innerSpan.style["line-height"] = settings.lineHeight;
    }
  }
}

// Calculate height without padding.
function innerHeight(el) {
  const style = window.getComputedStyle(el, null);
  return (
    el.getBoundingClientRect().height -
    parseInt(style.getPropertyValue("padding-top"), 10) -
    parseInt(style.getPropertyValue("padding-bottom"), 10)
  );
}

// Calculate width without padding.
function innerWidth(el) {
  const style = window.getComputedStyle(el, null);
  return (
    el.getBoundingClientRect().width -
    parseInt(style.getPropertyValue("padding-left"), 10) -
    parseInt(style.getPropertyValue("padding-right"), 10)
  );
}

//Returns true if it is a DOM element
function isElement(o) {
  return typeof HTMLElement === "object"
    ? o instanceof HTMLElement //DOM2
    : o &&
        typeof o === "object" &&
        o !== null &&
        o.nodeType === 1 &&
        typeof o.nodeName === "string";
}

// Convert line height value to pixels for multi-line detection
function getLineHeightInPixels(element, lineHeight) {
  const fontSize = parseInt(window.getComputedStyle(element)["font-size"], 10);

  if (lineHeight === "normal") {
    return fontSize * 1.2; // Browser default is usually around 1.2
  }

  // If it's a number (like "1.5"), multiply by font size
  const numericValue = parseFloat(lineHeight);
  if (
    !isNaN(numericValue) &&
    lineHeight.toString() === numericValue.toString()
  ) {
    return fontSize * numericValue;
  }

  // If it ends with px, em, rem, etc., try to calculate
  if (lineHeight.endsWith("px")) {
    return parseFloat(lineHeight);
  }

  if (lineHeight.endsWith("em")) {
    return fontSize * parseFloat(lineHeight);
  }

  if (lineHeight.endsWith("rem")) {
    const rootFontSize = parseFloat(
      window.getComputedStyle(document.documentElement)["font-size"]
    );
    return rootFontSize * parseFloat(lineHeight);
  }

  if (lineHeight.endsWith("%")) {
    return fontSize * (parseFloat(lineHeight) / 100);
  }

  // Fallback: assume it's a multiplier
  return fontSize * (numericValue || 1.2);
}

export default fitText;
